import { createContext } from "react";
// Creating the context object and passing the default values.
const DelayReasonContext = createContext({
  delayReasonstate: [],
  addDelayReason: () => {},
  updateDelayReason:()=>{},
  deleteDelayReason:()=>{},
});
export default DelayReasonContext;
